import React, { useState } from "react";
import { API_BASE_URL } from "../../API/endpoint";

export const CategoryForm = ({ category, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    name: category.name || "",
    image: null,
    id: category.id,
  });
  const [imagePreview, setImagePreview] = useState(
    category.path ? `${API_BASE_URL}${category.path}` : null
  );

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, image: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = new FormData();
    dataToSend.append("name", formData.name);
    if (formData.image) {
      dataToSend.append("image", formData.image);
    }
    if (formData.id) {
      dataToSend.append("id", formData.id);
    }
    onSave(dataToSend);
  };

  return (
    <div className="admin-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nom</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </div>
        <div className="form-group">
          <label>Image de la catégorie</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {imagePreview && (
            <div style={{ marginTop: "10px" }}>
              <img
                src={imagePreview}
                alt="Aperçu"
                style={{
                  maxWidth: "200px",
                  maxHeight: "200px",
                  objectFit: "contain",
                  border: "1px solid #ddd",
                  padding: "5px",
                }}
              />
            </div>
          )}
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-save">
            Enregistrer
          </button>
          <button type="button" className="btn-cancel" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};
